import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Linkedin, Youtube } from "lucide-react";
import ASSETS from "@/lib/assets";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" {...props}>
    <path d="M19.6 7.7a5.7 5.7 0 0 1-3.4-1.1 5.7 5.7 0 0 1-2.2-3.5h-3v12.6a2.7 2.7 0 1 1-2.7-2.7c.3 0 .5 0 .8.1V10a5.7 5.7 0 1 0 4.9 5.7V9.3a8.7 8.7 0 0 0 5 1.6V7.8c0-.1-1.4-.1-1.4-.1z" />
  </svg>
);

const Footer = () => (
  <footer className="footer" data-testid="site-footer">
    <div className="container-x">
      {/* Navigation columns */}
      <div className="footer-grid">
        <div>
          <h5>Navigate</h5>
          <Link to="/" data-testid="footer-nav-home">Home</Link>
          <Link to="/about" data-testid="footer-nav-about">About</Link>
          <Link to="/programs" data-testid="footer-nav-programs">Programs</Link>
          <Link to="/coaching" data-testid="footer-nav-coaching">1:1 Coaching</Link>
          <Link to="/freebie" data-testid="footer-nav-freebie">Free Resource</Link>
          <Link to="/newsletter" data-testid="footer-nav-newsletter">Newsletter</Link>
        </div>

        <div>
          <h5>Connect</h5>
          <Link to="/contact" data-testid="footer-connect-apply">Apply Now</Link>
          <a
            href="https://www.skool.com/the-legacy-lounge-free-7046/about?ref=4aecf50ea0e64eb0924b177d6890a1fb"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-connect-lounge"
          >
            The Legacy Lounge
          </a>
          <a
            href="https://nijahalmondgroup.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-connect-consulting"
          >
            Consulting Group ↗
          </a>
          <Link to="/contact" data-testid="footer-connect-contact">Contact</Link>
        </div>

        <div>
          <h5>Reach Out</h5>
          <a href="mailto:info@nijahalmond.com" data-testid="footer-email">info@nijahalmond.com</a>
          <a href="tel:+12409419948" data-testid="footer-phone">(240) 941-9948</a>
          <a
            href="https://www.nijahalmond.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-website"
          >
            www.nijahalmond.com
          </a>
          <p style={{ fontSize: 12, color: "rgba(253,248,245,.55)", marginTop: 6 }}>
            Available nationwide &amp; virtually. Replies within 48 business hours.
          </p>
        </div>
      </div>

      {/* Centered brand block — wordmark + tagline + socials */}
      <div className="footer-brand-block" data-testid="footer-brand">
        <img
          src={ASSETS.wordmark}
          alt="Nijah Almond"
          className="footer-wordmark-centered"
        />
        <p className="footer-tagline">
          <strong>Nijah Almond Coaching and Consultancy LLC</strong>
          {" "}— Identity coaching for high-performing women ready to return to themselves.
        </p>
        <div className="social-row" style={{ justifyContent: "center" }}>
          <a href="https://instagram.com/nijahalmond" target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-ig"><Instagram size={16} /></a>
          <a href="https://facebook.com/nijahalmond" target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="footer-fb"><Facebook size={16} /></a>
          <a href="https://linkedin.com/in/nijahalmond" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" data-testid="footer-li"><Linkedin size={16} /></a>
          <a href="https://tiktok.com/@nijahalmond" target="_blank" rel="noopener noreferrer" aria-label="TikTok" data-testid="footer-tt"><TikTokIcon /></a>
          <a href="https://youtube.com/@nijahalmond" target="_blank" rel="noopener noreferrer" aria-label="YouTube" data-testid="footer-yt"><Youtube size={16} /></a>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Nijah Almond. All rights reserved.</span>
        <span style={{ display: "flex", gap: 18 }}>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/disclaimer">Disclaimer</Link>
        </span>
      </div>

      <address className="footer-address" data-testid="footer-address">
        919 W 34th St #50278 &nbsp;·&nbsp; SMB #84124 &nbsp;·&nbsp; Baltimore, MD 21211
      </address>
    </div>
  </footer>
);

export default Footer;
